module.exports = __webpack_public_path__ + "static/media/transporter-1.a2e66ddd.svg";